import randomString from 'random-string';
export const createRequestId = () => `rid${randomString({
    length: 17,
    exclude: ['l', 'I']
})}`;
